import {http} from '../http'
import * as corePhotos from '../../coreApi/photos'

import {APIResponse} from '../types'
import {AlbumTagStats, ResourceID} from '../../../types'
import {handleError} from '../handleError'

type GetAlbumTagStatsReturn = APIResponse<AlbumTagStats>

export interface GetAlbumTagStats {
  (clientID: ResourceID, albumID: ResourceID): Promise<GetAlbumTagStatsReturn>
}

const ERROR_PATH = 'api.photos.getAlbumTagStats()'
const GENERIC_ERROR =
  'Something went wrong while loading album tag stats. Please try again.'

export const getAlbumTagStats: GetAlbumTagStats = async (clientID, albumID) => {
  let resolvedResponse: GetAlbumTagStatsReturn

  try {
    // The photos service enforces the authoritative `campminderstaff` gate and
    // 403s non-staff callers, so the server contract is the source of truth; the
    // client-side employee affordance is only a UX/defense-in-depth convenience.
    const response = await corePhotos.getAlbumTagStats(http, {
      ClientID: parseInt(clientID, 10),
      AlbumID: parseInt(albumID, 10),
    })

    if (!response || !response.data) {
      throw new Error('Unsuccessful Get Album Tag Stats')
    }

    resolvedResponse = {
      result: 'success',
      data: {
        // Coalesce each count at the decode boundary so a field omitted by the
        // server surfaces as 0 rather than undefined.
        frTagCount: response.data.frTagCount ?? 0,
        uniquePersonCount: response.data.uniquePersonCount ?? 0,
        manualTagCount: response.data.manualTagCount ?? 0,
      },
    }
  } catch (e) {
    resolvedResponse = handleError(ERROR_PATH, GENERIC_ERROR, e)
  }

  return Promise.resolve(resolvedResponse)
}
